import React, { useContext, useState } from 'react'
import Sidebar from '../Sidebar'
import { addcontext } from '../../ContextShare/ContextShare'
import klaimage from '../../Assets/kla-logo.png'
import TableSession from '../Session/TableSession'
import TableMember from '../Member/TableMember'
import TableComplaints from '../Complaints/TableComplaints'
import DbStatus from '../DbStatus/DbStatus'
import { Icon } from '@iconify/react/dist/iconify.js'

function DbStatusR() {
    const { addKLA, setaddKLA } = useContext(addcontext)
    const { selectedButton, setSelectedButton } = useContext(addcontext)
    const { isSidebarCloses, setIsSidebarCloses } = useContext(addcontext)

    const handleAddKLA = () => {
        setaddKLA(!addKLA)
    }
    return (
        <>
            <div className='flex w-full h-full ' style={{ fontFamily: 'ropa sans' }}>
                <div className='flex flex-col w-full h-full'>

                    <div className='w-full h-24 flex flex-row justify-between bg-success rounded border ' style={{ height: '13vh' }}>
                        {/* logo */}
                        <div className='w-2/12 flex items-center'>
                            <img src={klaimage} className='w-6/12 ms-12 lg:flex hidden p-1' alt="" /></div>
                        <div className='flex items-center' onClick={() => setIsSidebarCloses(!isSidebarCloses)}>
                        <Icon icon="teenyicons:expand-solid" className='text-2xl font-bold  cursor-pointer'/>
                        </div>

                        {/* navbar */}
                        {/* <div className='w-10/12 flex flex-row justify-center items-center'>
                            <div className='w-full flex justify-center'>
                                <div className='flex flex-row  px-1 border border-dashed border-green-300 h-11 items-center justify-between rounded-full w-5/12' >
                                    <button
                                        className={`w-40 py-1 rounded-full  ${selectedButton == 'ds' ? 'bg-green-500 text-white font-bold' : ' text-gray-700 hover:bg-green-200'}`}
                                        onClick={() => setSelectedButton('ds')}
                                    >
                                        Database Status
                                    </button>
                                    <button
                                        className={`w-40 py-1 rounded-full  ${selectedButton == 'cs' ? 'bg-green-500 text-white font-bold' : ' text-gray-700 hover:bg-green-200'}`}
                                        onClick={() => setSelectedButton('cs')}
                                    >
                                        Current Status
                                    </button>

                                    <button
                                        className={`w-40 py-1 rounded-full ${selectedButton == 'al' ? 'bg-green-500 text-white font-bold' : ' text-gray-700 hover:bg-green-200'}`}
                                        onClick={() => setSelectedButton('al')}
                                    >
                                        Activity Log
                                    </button>
                                </div>
                            </div>
                        </div> */}

                        {/* new navbar */}
                        <div className='w-10/12 flex flex-row justify-center pr-5 items-center '>
                            <div className='flex flex-row bg-white rounded-xl border shadow text-l font-bold'>

                                <div onClick={() => setSelectedButton('ds')} className={`cursor-pointer border-b-4 hover:border-blue-500 border-white w-36 text-center pt-2 pb-1 rounded-s-xl text-blue-500 transform duration-100 ease-in-out ${selectedButton == 'ds' && 'bg-blue-100 text-blue-700 border-blue-100'}`}><button className=''>Database Status</button></div>

                                <div className=' w-1 bg-gray-300 '></div>

                                <div onClick={() => setSelectedButton('cs')} className={`cursor-pointer border-b-4 hover:border-blue-500 border-white w-36 text-center pt-2 pb-1 text-blue-500 transform duration-100 ease-in-out ${selectedButton == 'cs' && 'bg-blue-100 text-blue-700 border-blue-100'}`}><button>Current Status</button></div>

                                <div className=' w-1 bg-gray-300 '></div>

                                <div onClick={() => setSelectedButton('al')} className={`cursor-pointer border-b-4 hover:border-blue-500 border-white w-36 text-center pt-2 pb-1 rounded-e-xl text-blue-500 transform duration-100 ease-in-out ${selectedButton == 'al' && 'bg-blue-100 text-blue-700 border-blue-100'}`}><button>Activity Log</button></div>

                            </div>
                        </div>

                    </div>

                    <div className='flex flex-row'>

                        <div className={`${isSidebarCloses && 'hidden'} md:w-4/12 lg:w-3/12 xl:w-2/12`}>
                            <Sidebar />
                        </div>


                        {/* Table */}
                        <div className={`${isSidebarCloses ? 'w-full' : 'lg:w-9/12 xl:w-10/12 w-full'} overflow-y-scroll pt-2 `} style={{ height: '87vh' }}>
                            <DbStatus />
                        </div>
                    </div>
                </div></div>
        </>
    )
}

export default DbStatusR